import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactSVG from 'react-svg';
import { clearAllBodyScrollLocks } from 'body-scroll-lock';
import { decode } from 'html-decoder';
import times from 'times.svg';
import ErrorBoundary from '../ErrorBoundary';

// Build an array of objects for grouping amenities together
// [{ group_name: 'General', amenities: [{...}] }, { group_name: 'Kitchen', amenities: [{...}] }]

function AmenitiesModal({ showModal, toggleModal, amenities }) {
  useEffect(() => {
    const amenityList = document.getElementById('amenities-list');
    // Add if statement because Edge, IE, and Safari IOS hate the web and don't support element.scrollTo
    if (amenityList.scrollTop) amenityList.scrollTo(0, 0);
  }, [showModal]);

  const groupedAmenities = [];
  amenities.forEach(amenity => {
    if (!groupedAmenities.length) {
      groupedAmenities.push({
        group_name: amenity.table.group_name,
        amenities: [amenity.table.amenity_name],
      });
    } else if (
      groupedAmenities.some(ga => ga.group_name === amenity.table.group_name)
    ) {
      const index = groupedAmenities.findIndex(
        ga => ga.group_name === amenity.table.group_name
      );
      groupedAmenities[index].amenities.push(amenity.table.amenity_name);
    } else {
      groupedAmenities.push({
        group_name: amenity.table.group_name,
        amenities: [amenity.table.amenity_name],
      });
    }
  });

  return (
    <div className={`modal-container ${!showModal ? 'hidden' : ''}`}>
      <div id="review_modal_backdrop" className="modal-backdrop" />

      <div className="modal amenities">
        <button
          aria-label="Close Amenities Modal"
          name="Close Amenities Modal"
          type="button"
          className="close-modal"
          onClick={() => {
            toggleModal(false);
            clearAllBodyScrollLocks();
            document.querySelector('body').style.overflow = '';
          }}
        >
          <ReactSVG src={times} />
        </button>

        <div className="amenities-wrapper">
          <h3 className="modal-title">Amenities</h3>
          <main className="amenities-list" id="amenities-list">
            {groupedAmenities.map((ga, index) => (
              <section key={index} className="grouped-amenity-section">
                <h3 className="grouped-amenity-title">{ga.group_name}</h3>
                <div className="grouped-amenity-list">
                  {ga.amenities.map((amenity, ind) => (
                    <p key={ind} className="grouped-amenity">
                      {decode(amenity)}
                    </p>
                  ))}
                </div>
              </section>
            ))}
          </main>
        </div>
      </div>
    </div>
  );
}

AmenitiesModal.propTypes = {
  showModal: PropTypes.bool,
  toggleModal: PropTypes.func.isRequired,
  amenities: PropTypes.array.isRequired,
};

export default function AmenitiesModalWrapper({ ...props }) {
  return (
    <ErrorBoundary>
      <AmenitiesModal {...props} />
    </ErrorBoundary>
  );
}
